"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Questionnaire24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "questionnaire-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M22,1 L22,23 L2,23 L2,1 L22,1 Z M20,3 L4,3 L4,21 L20,21 L20,3 Z M16,15 L16,17 L14,17 L14,15 L16,15 Z M11,15 L11,17 L6,17 L6,15 L11,15 Z M15.0325123,7 C16.4338122,7 18,7.96 18,9.4 C18,10.4302814 17.448432,11.7210174 16.6737335,12.2785889 C15.9026458,12.8335617 16,13.436 16,14 L14,14 C14,13 14,12.1319871 15.0325123,11.4424285 C16.0650246,10.7528699 16,10.3389753 16,9.81097534 C16,9.32497534 15.555665,9 15,9 C14.4325123,9 14.017734,9.418 14,10 L12,10 C12.017734,8.428 13.2957234,7 15.0325123,7 Z M11,11 L11,13 L6,13 L6,11 L11,11 Z M10,7 L10,9 L6,9 L6,7 L10,7 Z", id: "Combined-Shape", fill: "#000000", fillRule: "nonzero" })));
}
function Questionnaire24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Questionnaire24Svg, Object.assign({}, svgProps)));
}
exports.default = Questionnaire24;
//# sourceMappingURL=Questionnaire24.js.map